import { LEARNER_ASSIGNMENT_COUNTS_QUERY_KEY } from "./learnerAssignmentQueryKeys";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { serialize } from "../../utils/url";
import { ILearnerAssignmentCounts } from "../types";

export interface ILearnerAssignmentCountsQueryParameters {
    filters?: {
        /** Counts only the assignments of that classroom, so the tabs speak of the list under them */
        classroom?: string;
    };
}

export type ILearnerAssignmentCountsQueryResult = ILearnerAssignmentCounts;

export const learnerAssignmentCountsQuery: IApiQueryFunction<ILearnerAssignmentCountsQueryParameters> = ({
    filters,
}) => ({
    method: "GET",
    url: `/learner_assignment_counts${serialize({ classroom: filters?.classroom }, true)}`,
});

const useQuery = createApiQueryHook<ILearnerAssignmentCountsQueryParameters, ILearnerAssignmentCountsQueryResult>(
    learnerAssignmentCountsQuery,
);

export const useLearnerAssignmentCountsQuery = (
    parameters: ILearnerAssignmentCountsQueryParameters,
    options: Omit<NonNullable<Parameters<typeof useQuery>[1]>, "queryKey"> = {},
) => useQuery(parameters, { ...options, queryKey: [LEARNER_ASSIGNMENT_COUNTS_QUERY_KEY, "counts", parameters] });
